import { render, staticRenderFns } from "./MapPatent.vue?vue&type=template&id=5039591a&scoped=true"
import script from "./MapPatent.vue?vue&type=script&lang=js"
export * from "./MapPatent.vue?vue&type=script&lang=js"
import style0 from "./MapPatent.vue?vue&type=style&index=0&id=5039591a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5039591a",
  null
  
)

export default component.exports